import React from "react";
import { getCurrentBetsAPI } from "../service/AuthService";
import moment from "moment";
import { useSelector } from "react-redux";

export default function RightSidebar() {
  const [data, setData] = React.useState(null);
  const [payload, setPayload] = React.useState({
    betStatus: "MATCHED",
    betType: "ALL",
    pageNumber: 0,
    pageSize: 1000,
    search: "",
    sports: true,
  });
  const [uniqueEvents, setUniqueEvents] = React.useState([]);
  const [selectedEvent, setSelectedEvent] = React.useState(null);
  const userData = useSelector((state) => state.account.userData);
  const getCurrentBets = async () => {
    const { response } = await getCurrentBetsAPI(payload);
    setData(response?.unsettledBets?.content);
    let uniqueEvents = Array.from(
      new Set(response?.unsettledBets?.content.map((item) => item.event_name))
    );
    setUniqueEvents(uniqueEvents);
  };
  const [betInfo, setBetInfo] = React.useState(null);

  React.useEffect(() => {
    if (userData?.token) getCurrentBets();
  }, []);
  return (
    <div
      _ngcontent-ng-c1893399002=""
      className="sidebarright hideDekstop"
      style={{ width: "27vw" }}
    >
      <app-right-nav _ngcontent-ng-c1893399002="" _nghost-ng-c4093098567="">
        <div
          _ngcontent-ng-c4093098567=""
          style={{ width: "26.15vw", position: "fixed" }}
        >
          <div _ngcontent-ng-c4093098567="" className="card">
            {/**/}
            <div
              _ngcontent-ng-c4093098567=""
              id="live-Streaming"
              className="accordion-body"
            >
              {/**/}
            </div>
            <div _ngcontent-ng-c4093098567="" className="card-header">
              <strong
                _ngcontent-ng-c4093098567=""
                style={{ position: "relative", top: "0.5px" }}
              >
                Open Bets
              </strong>
            </div>
            <div
              _ngcontent-ng-c4093098567=""
              className="card-body open-bet-btns"
            >
              <div
                _ngcontent-ng-c4093098567=""
                className="col-sm-12 p-0 mlist-openbets ng-star-inserted"
              >
                <select
                  _ngcontent-ng-c4093098567=""
                  id="eventNameSelect"
                  onChange={(e) => {
                    setSelectedEvent(e.target.value);
                  }}
                  className="desktop-bets"
                >
                  <option
                    _ngcontent-ng-c4093098567=""
                    value="undefined,undefined"
                    className="ng-star-inserted"
                  >
                    {" "}
                    Select Market
                  </option>
                  {data &&
                    //unique event names
                    uniqueEvents.map((item) => (
                      <option
                        _ngcontent-ng-c4093098567=""
                        className="ng-star-inserted"
                        value={item}
                      >
                        {" "}
                        {item}
                      </option>
                    ))}
                </select>
                <nav
                  _ngcontent-ng-c4093098567=""
                  className="all-sports-list ng-star-inserted"
                >
                  <div _ngcontent-ng-c4093098567="" className="content-534">
                    <div
                      _ngcontent-ng-c4093098567=""
                      className="act-16a tab-ltq"
                    >
                      <div
                        _ngcontent-ng-c4093098567=""
                        id="dplql"
                        name="txn"
                        className="list-5fh"
                      >
                        <ul
                          _ngcontent-ng-c4093098567=""
                          className="nav nav-tabs"
                        >
                          <li
                            _ngcontent-ng-c4093098567=""
                            className="nav-item text-center"
                          >
                            <a
                              _ngcontent-ng-c4093098567=""
                              className="nav-link active fw-bold"
                            >
                              <span _ngcontent-ng-c4093098567="">Matched</span>
                            </a>
                          </li>
                        </ul>
                        <ul
                          _ngcontent-ng-c4093098567=""
                          id="bac-xxb"
                          className="matched-826 unity-ul-d78"
                        >
                          <li _ngcontent-ng-c4093098567="" className="col-fpg">
                            Back (Bet For)
                          </li>
                          <li _ngcontent-ng-c4093098567="" className="col-1ie">
                            Odds
                          </li>
                          <li _ngcontent-ng-c4093098567="" className="col-mlt">
                            Stake
                          </li>
                          <li _ngcontent-ng-c4093098567="" className="col-wcg">
                            Profit
                          </li>
                        </ul>
                        <div
                          _ngcontent-ng-c4093098567=""
                          className="right-betslip-data"
                        >
                          {data
                            ?.filter(
                              (item) =>
                                item?.event_name == selectedEvent &&
                                (item?.back_rate || item?.back_run)
                            )
                            ?.map((item) => (
                              <dl
                                _ngcontent-ng-c4093098567=""
                                id="txn-ley"
                                className="slip-3ga ng-star-inserted"
                              >
                                {betInfo && (
                                  <dd
                                    _ngcontent-ng-c4093098567=""
                                    id="bet-yq1"
                                    className="ref-epq ng-star-inserted"
                                  >
                                    <span
                                      _ngcontent-ng-c4093098567=""
                                      id="bet-bjr"
                                    >
                                      Ref:{" "}
                                    </span>
                                    <span
                                      _ngcontent-ng-c4093098567=""
                                      id="pla-fpm"
                                    >
                                      30-09-2024 23:09:05
                                    </span>
                                  </dd>
                                )}
                                <dt _ngcontent-ng-c4093098567="">
                                  <span
                                    _ngcontent-ng-c4093098567=""
                                    className="slip-ys5 ng-star-inserted"
                                  >
                                    {item?.back_rate || item?.back_run
                                      ? "Back"
                                      : "Lay"}
                                  </span>
                                  {/**/}
                                  <span
                                    _ngcontent-ng-c4093098567=""
                                    className="short-nbw ng-star-inserted"
                                  >
                                    {item?.runner_name}
                                  </span>
                                  {/**/}
                                  <span
                                    _ngcontent-ng-c4093098567=""
                                    id="mar-l2h"
                                    className="marketNameEclispes ng-star-inserted"
                                  >
                                    {item?.marketName}
                                  </span>
                                  {/**/}
                                </dt>
                                <dd
                                  _ngcontent-ng-c4093098567=""
                                  id="pri-a35"
                                  className="col-1ie ng-star-inserted"
                                >
                                  {item?.back_rate || item?.back_run}
                                </dd>
                                {/**/}
                                <dd
                                  _ngcontent-ng-c4093098567=""
                                  id="siz-lp2"
                                  title="$10"
                                  className="col-mlt ng-star-inserted"
                                >
                                  {item?.amount}
                                </dd>
                                {/**/}
                                <dd
                                  _ngcontent-ng-c4093098567=""
                                  id="pro-l8k"
                                  className="col-wcg ng-star-inserted"
                                >
                                  <span
                                    _ngcontent-ng-c4093098567=""
                                    className="p-0"
                                  >
                                    {item?.profit}
                                  </span>
                                  <span
                                    _ngcontent-ng-c4093098567=""
                                    className="p-0"
                                  >
                                    {" "}
                                    (-{item?.loss}){" "}
                                  </span>
                                </dd>
                                {/**/}
                              </dl>
                            ))}
                          {/**/}
                          {/**/}
                          {/**/}
                          <ul
                            _ngcontent-ng-c4093098567=""
                            id="lay-zc9"
                            className="matched-826 unity-ul-d78"
                          >
                            <li
                              _ngcontent-ng-c4093098567=""
                              className="col-fpg"
                            >
                              Lay (Bet Against)
                            </li>
                            <li
                              _ngcontent-ng-c4093098567=""
                              className="col-1ie"
                            >
                              Odds
                            </li>
                            <li
                              _ngcontent-ng-c4093098567=""
                              className="col-mlt"
                            >
                              Stake
                            </li>
                            <li
                              _ngcontent-ng-c4093098567=""
                              className="col-wcg"
                            >
                              Liability
                            </li>
                          </ul>
                          {data
                            ?.filter(
                              (item) =>
                                item?.event_name == selectedEvent &&
                                (item?.lay_rate || item?.lay_run)
                            )
                            ?.map((item) => (
                              <dl
                                _ngcontent-ng-c4093098567=""
                                id="txn-ley"
                                className="slip-y8o ng-star-inserted"
                              >
                                {betInfo && (
                                  <dd
                                    _ngcontent-ng-c4093098567=""
                                    id="bet-yq1"
                                    className="ref-epq ng-star-inserted"
                                  >
                                    <span
                                      _ngcontent-ng-c4093098567=""
                                      id="bet-bjr"
                                    >
                                      Ref:{" "}
                                    </span>
                                    <span
                                      _ngcontent-ng-c4093098567=""
                                      id="pla-fpm"
                                    >
                                      {moment(item?.created_at + "Z").format(
                                        "DD-MM-YYYY hh:mm:ss"
                                      )}
                                    </span>
                                  </dd>
                                )}
                                <dt _ngcontent-ng-c4093098567="">
                                  <span
                                    _ngcontent-ng-c4093098567=""
                                    className="slip-ys5 ng-star-inserted"
                                  >
                                    {item?.lay_rate || item?.lay_run
                                      ? "Lay"
                                      : "Lay"}
                                  </span>
                                  {/**/}
                                  <span
                                    _ngcontent-ng-c4093098567=""
                                    className="short-nbw ng-star-inserted"
                                  >
                                    {item?.runner_name}
                                  </span>
                                  {/**/}
                                  <span
                                    _ngcontent-ng-c4093098567=""
                                    id="mar-l2h"
                                    className="marketNameEclispes ng-star-inserted"
                                  >
                                    {item?.marketName}
                                  </span>
                                  {/**/}
                                </dt>
                                <dd
                                  _ngcontent-ng-c4093098567=""
                                  id="pri-a35"
                                  className="col-1ie ng-star-inserted"
                                >
                                  {item?.lay_rate || item?.lay_run}
                                </dd>
                                {/**/}
                                <dd
                                  _ngcontent-ng-c4093098567=""
                                  id="siz-lp2"
                                  title="$10"
                                  className="col-mlt ng-star-inserted"
                                >
                                  {item?.amount}
                                </dd>
                                {/**/}
                                <dd
                                  _ngcontent-ng-c4093098567=""
                                  id="pro-l8k"
                                  className="col-wcg ng-star-inserted"
                                >
                                  <span
                                    _ngcontent-ng-c4093098567=""
                                    className="p-0"
                                  >
                                    {item?.profit}
                                  </span>
                                  <span
                                    _ngcontent-ng-c4093098567=""
                                    className="p-0"
                                  >
                                    {" "}
                                    (-{item?.loss}){" "}
                                  </span>
                                </dd>
                                {/**/}
                              </dl>
                            ))}
                          <div _ngcontent-ng-c4093098567="" className="btn-gad">
                            <ul
                              _ngcontent-ng-c4093098567=""
                              className="option-g3c unity-ul-d78"
                            >
                              <li _ngcontent-ng-c4093098567="">
                                <input
                                  _ngcontent-ng-c4093098567=""
                                  id="showBetInfo"
                                  name="openOption"
                                  type="checkbox"
                                  disabled
                                  onClick={() => setBetInfo(!betInfo)}
                                />
                                <label
                                  _ngcontent-ng-c4093098567=""
                                  htmlFor="showBetInfo"
                                >
                                  Bet Info
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </nav>
                {/**/}
              </div>
              {/**/}
            </div>
            {/**/}
          </div>
        </div>
      </app-right-nav>
    </div>
  );
}
